import { IChungChiChungNhanSinhVienActionTypes } from "../../action-types/chung-chi-chung-nhan/chungChiChungNhanSinhVienActions";
import { IChungChiChungNhanSinhVienReducer } from "../../reducer-model/chung-chi-chung-nhan/IChungChiChungNhanSinhVienReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState : IChungChiChungNhanSinhVienReducer = {
    status: eReducerStatusBase.is_not_initialization,
    chungChiChungNhanSinhViens: [],
};

export const chungChiChungNhanSinhVienReducer = (state: IChungChiChungNhanSinhVienReducer = iniState, action: IChungChiChungNhanSinhVienActionTypes): IChungChiChungNhanSinhVienReducer => {
    switch (action.type) {
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                chungChiChungNhanSinhViens: action.payload,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_DELETES_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_DELETES_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_DELETES_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_UPLOAD_MODAL_OPEN":
            return {
                ...state,
                importModal: {
                    isShow: true,
                    mark_chungchichungnhan_id: action.payload,
                },
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_UPLOAD_MODAL_CLOSE":
            return {
                ...state,
                importModal: {
                    isShow: false,
                    mark_chungchichungnhan_id: 0,
                },
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_LOAD_BY_CHUNG_CHI_CHUNG_NHAN_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_LOAD_BY_CHUNG_CHI_CHUNG_NHAN_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                chungChiChungNhanSinhViens: action.payload,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN_LOAD_BY_CHUNG_CHI_CHUNG_NHAN_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }   
}